import { useState, useContext, Fragment } from "react";
import styled from "styled-components";
import CardConstructor from "./CardConstructor";
import Modal from "./Modal";
import { AppContext } from "../App";

const ClaimLife = ({ open }: { open: boolean }) => {
  const isSmallScreen = window.innerWidth <= 650;
  const { setClaim: close } = useContext(AppContext);
  const [claimed, setClaimed] = useState<boolean>(false);

  const reset = () => {
    setClaimed(!claimed);
  };

  return (
    <Modal isOpen={open}>
      <Wrapper isOpen={open}>
        <CardConstructor
          $margin={"0 auto"}
          $width={"45%"}
          centered={false}
          aboveTitleContent={
            !claimed ? (
              <button
                className="btn-flat btn navigation-btn"
                onClick={() => close()}
              >
                <i className="material-icons">arrow_back</i> Back
              </button>
            ) : (
              <></>
            )
          }
          title={
            !claimed ? (
              <h5 className="claim-title">Claim your Life Plan</h5>
            ) : (
              <h5 className="claim-title">
                Thanks — <br />
                you’re on the list.
              </h5>
            )
          }
          content={
            <div>
              {!claimed ? (
                <Fragment>
                  <p className="content-subtitle">
                    %MyLifePlan value prop oneliner / waitlist opener, up to two
                    lines, but keep concise and cool
                  </p>
                </Fragment>
              ) : (
                <></>
              )}
              <div className="form-area">
                {!claimed ? (
                  <Fragment>
                    <span>Name</span>
                    <input type="text" name="name" id="name" />
                    <span>Email</span>
                    <input type="email" name="email" />
                    <span className="info-text">
                      Freddie don’t send spam to his contacts.
                    </span>
                  </Fragment>
                ) : (
                  <p className="claimed-info-text">
                    Freddie or someone from his team will be in touch <br />
                    with early access and updates.
                  </p>
                )}
                <div>
                  {!claimed ? (
                    <button
                      className={`btn ${isSmallScreen ? "" : "btn-large"} z-depth-0`}
                      onClick={() => setClaimed(!claimed)}
                    >
                      Join the Waitlist
                    </button>
                  ) : (
                    <div>
                      <button className="btn z-depth-0 sent-indicator" disabled>
                        <i className="large material-icons">check</i>
                      </button>
                      <button
                        className="btn black z-depth-0"
                        onClick={() => {
                          close();
                          reset();
                        }}
                      >
                        close
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          }
        />
      </Wrapper>
    </Modal>
  );
};

const Wrapper = styled.div<{ isOpen: boolean }>`
  display: ${({ isOpen }) => (isOpen ? "block" : "none")};
  .claim-title {
    font-size: 35px;
    letter-spacing: -0.3px;
    font-weight: 700;
    font: inter;
  }

  .form-area {
    margin-top: 25px;
  }

  .form-area span {
    font-size: 14px;
  }

  .form-area input {
    background-color: #f5f5f5;
    border: 1px solid #9e9e9e;
    border-radius: 6px;
    padding-left: 12px;
  }

  .form-area span.info-text {
    font-size: 12px;
    color: #9e9e9e;
  }

  div.form-area > div {
    margin-top: 15px;
  }

  div.form-area button {
    border-radius: 30px;
    text-transform: none;
    font-size: 16px;
    background-color: #243aff;
  }

  div.form-area input:focus {
    border-bottom: 1px solid #9e9e9e;
    box-shadow: none;
  }

  input[type="text"]:not(.browser-default):focus:not([readonly]) {
    border-bottom: 1px solid #9e9e9e;
    box-shadow: none;
  }

  div.form-area button.sent-indicator {
    background-color: #d2ffd1 !important;
    color: #00ac1f !important;
    margin-right: 10px;
  }

  p.claimed-info-text {
    margin-bottom: 121px;
  }

  button.navigation-btn {
    padding: 0;
    text-transform: none;
    align-items: center;
    display: flex;
    color: #243aff;
  }

  button.navigation-btn:hover {
    background-color: unset;
  }

  @media only screen and (max-width: 650px) {
    .claim-title {
      font-size: 22px;
    }

    .form-area {
      margin-top: 15px;
      padding-right: 15px;
    }

    .form-area span {
      font-size: 12px;
    }

    .content-subtitle {
      margin-top: -30px;
    }

    .form-area input {
      height: 2rem;
    }
  }
`;

export default ClaimLife;
